export enum AwardsTabs {
  DESCRIPTION = 'Description',
  ACHIEVEMENTS = 'Achievements',
  REWARDS = 'Rewards',
  FAQ = 'FAQ',
}

export const QUERY_PARAM = 'tab'
export const ORDER_PARAM = 'order'
